module.exports = __webpack_public_path__ + "assets/img/config-table-407f92a6.png";